<!--美育浸润首页-->
<!--党建引领管理-->
<template>
    <div class="app-container">
        <el-card v-has-btn="'1,2,'" class="mb15">
            <el-row>
                <el-col :span="16" class="mb0">
                    <el-button v-has-btn="'1,2'" @click="handleCreate" type="primary">新增美育浸润</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="90px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="所属主题" prop="myjrItem">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.myjrItem" placeholder="请选择">
                                <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                           :value="item.itemId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="类型" prop="myjrType">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.myjrType" placeholder="请选择">
                                <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                                           :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>


                </el-row>
                <el-row class="mt10">
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item label="年级段">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.myjrGrade" placeholder="请选择年级段">
                                <el-option v-for="item in myjrGradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="mr0 mb0"></el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.myjrName" placeholder="请输入标题" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :height="`calc(100vh - 370px)`"
                          v-loading="loading" :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column  label="标题" align="center" prop="myjrName">
                        <template #default="scope">
                            <div :title="scope.row.myjrName" @click="handleView(scope.row)" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.myjrName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column  label="主题" align="center" prop="myjrItemName">
                        <template #default="scope">
                            <div :title="scope.row.myjrItemName"
                                 class="text-one cursor">
                                {{ scope.row.myjrItemName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" label="学段·年级" align="center" prop="">
                        <template #default="scope">
                            <div :title="scope.row.periodName+''+scope.row.gradeName"
                                 class="text-one cursor">
                                {{ scope.row.periodName }}  {{ scope.row.gradeName?'| '+scope.row.gradeName: ''}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="年级段" align="center" prop="">
                        <template #default="scope">
                            <div :title="scope.row.myjrGradeName"
                                 class="text-one cursor">
                                {{ scope.row.myjrGradeName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="类型" align="center" prop="myjrType">
                        <template #default="scope">
                            <div v-if="scope.row.myjrType == 1" class="text-one">音乐</div>
                            <div v-if="scope.row.myjrType == 2" class="text-one">美术</div>
                            <div v-if="scope.row.myjrType == 3" class="text-one">主题班会</div>
                        </template>
                    </el-table-column>

                    <el-table-column width="180" label="上传时间" align="center" prop="createTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" align="center" label="操作"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="80" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleView(scope.row)">查看</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-popconfirm
                                              confirm-button-text="是"
                                              cancel-button-text="否"
                                              :icon="InfoFilled"
                                              icon-color="#626AEF"
                                              title="确定删除?"
                                              @confirm="handleDelete(scope.row)">
                                                <template #reference>
                                                    <el-text type="danger">删除</el-text>
                                                </template>
                                            </el-popconfirm>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="pageList" />
            </div>
        </el-card>


    </div>
</template>
<script>
import { queryDict } from "@/api/admin/public";
import {pageMyjr,deleteMyjr} from "@/api/admin/myjr"
import {timestampToTime} from "@/utils/date";
import {listItem} from "@/api/admin/item";
export default {
    name: "myjrIndex",
    components: {},
    data() {
        return {
            timestampToTime,
            loading: false,
            periodList:[],
            gradeList:[],
            myjrGradeList:[],
            itemList:[],
            typeList: [
                { name: '音乐', value: 1 },
                { name: '美术', value: 2 },
                { name: '主题班会', value: 3 },
            ],
            dataList:[],
            total:0,
            queryParams:{
                myjrName:'',
                periodKey:'',
                gradeKey:'',
                myjrType:'',
                myjrItem:'',
                myjrGrade:'',
                pageNum: 1,
                pageSize: 10,
            }
        };
    },
    created() {
        this.getQueryDict();
        this.queryItemList();
        this.pageList();
    },
    activated() {},
    watch: {},
    methods: {
        queryItemList(){
            listItem({ itemType: 1 }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageList(null)
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'myjr_grade_period' }).then(res => {
                this.myjrGradeList = res.data.data;
            })
        },
        handleCreate(){
            this.$router.push({
                path: "/myjrCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/myjrCreate",
                query: {
                    myjrId: row.myjrId,
                }
            });
        },
        handleDelete(row){
            deleteMyjr({ myjrId: row.myjrId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageMyjr(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleView(row){
            this.$router.push({
                path: "/myjrDetail",
                query: {
                    myjrId: row.myjrId,
                }
            });
        }
    }
}
</script>

<style scoped>
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>